export default function sharing( state = {
  ids: [],
}, action ) {
  switch ( action.type ) {
    case 'ADD_ID':
      return {
        ids: [...state.ids, action.id]
      };
    case 'CLEAR_IDS':
      return {
        ids: [],
      };
    default:
      return state;
  }
}
